import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Speaker } from 'lucide-react';
import { ReactNode } from 'react';
import { AccountActivationPanel } from './AccountActivationPanel';
import { TermsAcceptancePanel } from './TermsAcceptancePanel';
import { LEGAL_VERSION } from '../../config/legal';

interface ProtectedRouteProps {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isDJ, loading, termsAcceptedVersion, termsLoadFailed } = useAuth();
  const location = useLocation();

  const spinner = (
    <div className="min-h-screen flex items-center justify-center bg-background-light dark:bg-background-dark">
      <div className="animate-pulse">
        <Speaker className="w-12 h-12 text-primary" />
      </div>
    </div>
  );

  if (loading) {
    return spinner;
  }

  if (!user || user.isAnonymous) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (!isDJ) {
    return <AccountActivationPanel />;
  }

  if (termsLoadFailed) {
    return <TermsAcceptancePanel previousVersion={null} loadFailed />;
  }

  if (termsAcceptedVersion === undefined) {
    return spinner;
  }

  if (termsAcceptedVersion !== LEGAL_VERSION) {
    return <TermsAcceptancePanel previousVersion={termsAcceptedVersion} />;
  }

  return <>{children}</>;
}
